import { Control, UseFormWatch } from 'react-hook-form';
import { CustomSlider } from '@/components/ui/custom-slider';
import type { EditAssumptionsFormFields } from '../hooks';

interface CareAssumptionsSectionProps {
  control: Control<EditAssumptionsFormFields>;
  watch: UseFormWatch<EditAssumptionsFormFields>;
  previewClient: Client;
  updatePreviewClient: (updatedClient: Client) => void;
  predictedLtcAtAge: number;
}

export function CareAssumptionsSection({
  control,
  watch,
  previewClient,
  updatePreviewClient,
  predictedLtcAtAge,
}: CareAssumptionsSectionProps) {
  const currentAge = watch('ltcAtAge');
  const clientCurrentAge = previewClient.intakeSurvey.clientAge;
  const minAge = Math.max(50, clientCurrentAge + 1);
  const maxAge = 150;

  return (
    <div className="space-y-2">
      <h2 className="text-base font-semibold text-gray-900 sm:-mb-2 sm:text-lg">Care Start Age</h2>

      <div
        className="flex flex-col items-start gap-4 sm:flex-row sm:items-end sm:gap-6"
        data-testid="care-start-age-section"
      >
        <div className="flex shrink-0 items-baseline gap-2 pb-1">
          <span
            className="text-primary-dark text-3xl font-bold sm:text-4xl"
            data-testid="care-start-age-value"
          >
            {currentAge}
          </span>
          <span className="text-base text-gray-500 sm:text-lg">years old</span>
        </div>

        <div className="w-full sm:flex-1">
          <CustomSlider
            name="ltcAtAge"
            control={control}
            min={minAge}
            max={maxAge}
            defaultValue={predictedLtcAtAge}
            formatValue={value => `${value}`}
            defaultLabel="Reset to Predicted"
            showMinMax
            data-testid="care-start-age-slider"
            updateClient={value => {
              const updatedClient = {
                ...previewClient,
                clientCustomInferences: {
                  ...previewClient.clientCustomInferences,
                  ltcAtAge: value,
                },
              };
              updatePreviewClient(updatedClient);
            }}
          />
        </div>
      </div>
    </div>
  );
}
